import React, { useEffect, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";

const CheckoutForm = ({success_url, amount_to_pay,onSuccess}) => {
    const stripe = useStripe();
    const elements = useElements();
    //console.log(success_url);
    
    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
      if (!stripe) {
        return;
      }

      const clientSecret = new URLSearchParams(window.location.search).get(
        "payment_intent_client_secret"
      );

      if (!clientSecret) {
        return;
      }

      stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
        console.log(paymentIntent)
        switch (paymentIntent.status) {
          case "succeeded":
            setMessage("Payment succeeded!");

            break;
          case "processing":
            setMessage("Your payment is processing.");
            break;
          case "requires_payment_method":
            setMessage("Your payment was not successful, please try again.");
            break;
          default:
            setMessage("Something went wrong.");
            break;
        }
      });
    }, [stripe]);
     
   const handleSubmit = async (e) => {
  e.preventDefault();
  const tab = success_url.split('?');
  let query = tab[1] ?? '';
  const params = new URLSearchParams(query);
  const paymentId = params.get('paymentId');
  const currencyId = params.get('id_currency');
  const provider = params.get('provider');     

  if (!stripe || !elements) {
    return;
  }

  setIsLoading(true);

  const { error, paymentIntent } = await stripe.confirmPayment({
    elements,
    confirmParams: {
      return_url: success_url,
    },
    redirect: "if_required", // Ajoute ceci pour éviter la redirection automatique
  });

  if (error) {
    console.log("Erreur lors du paiement ", error);
    if (error.type === "card_error" || error.type === "validation_error") {
      setMessage(error.message);
    } else {
      setMessage("An unexpected error occurred.");
    }
    setIsLoading(false);
    return;
  }

  // Si le paiement est réussi sans redirection, déclenche onSuccess
  if (paymentIntent && paymentIntent.status === "succeeded") {
    if (typeof onSuccess === "function") {
      onSuccess(provider, paymentId, currencyId);
    }
    setMessage("Payment succeeded!");
  }

  setIsLoading(false);
};

    const paymentElementOptions = {
      layout: "tabs"
    }

    return (
      <form id="payment-form" onSubmit={handleSubmit}>

        <PaymentElement id="payment-element" options={paymentElementOptions} />
        <button disabled={isLoading || !stripe || !elements} id="submit" className='text-white bg-[#D19E06] hover:bg-black px-3 py-1 rounded my-4 text-center w-3/4 md:w-1/2 mx-auto block'>
          <span id="button-text">
            {isLoading ? <div className="spinner" id="spinner"></div> : "Payer Maintenant ("+ amount_to_pay +")"}
          </span>
        </button>
        {/* Show any error or success messages */}
        {message && <div id="payment-message">{message}</div>}
      </form>
    );
};

export default CheckoutForm;